// Thin wrapper around the toastr global. The application entrypoint
// (app/javascript/entrypoints/application.js) imports toastr once and assigns
// it to `window.toastr`, which is also how Rails flash messages are rendered
// (app/views/shared/_notifications.html.erb) - going through the global keeps
// React pages and server flashes in the same toast stack instead of bundling a
// second copy of toastr into every page.

type ToastLevel = 'success' | 'error' | 'warning' | 'info'

type Toastr = Record<ToastLevel, (message: string, title?: string) => unknown>

declare global {
  interface Window {
    toastr?: Toastr
  }
}

// Shows a toast, or logs when toastr is unavailable. Deliberately never falls
// back to window.alert: a native dialog blocks the page, looks nothing like the
// rest of the UI, and cannot be styled or dismissed with the app's own chrome.
export function notify(level: ToastLevel, message: string): void {
  const toastr = typeof window === 'undefined' ? undefined : window.toastr

  if (!toastr) {
    console.warn(`[${level}] ${message}`)
    return
  }

  toastr[level](message)
}

export function notifySuccess(message: string): void {
  notify('success', message)
}

export function notifyError(message: string): void {
  notify('error', message)
}
